import GithubSlugger from 'github-slugger'

export interface H2Section {
  title: string   // raw heading text (includes any numeric prefix)
  slug: string    // matches the id emitted by rehype-slug
}

export function parseH2Sections(body: string): H2Section[] {
  const slugger = new GithubSlugger()   // fresh per call — stateful for duplicate suffixing within a single parse
  const h2s: H2Section[] = []
  for (const line of body.split(/\r?\n/)) {
    const m = line.match(/^##\s+(.+?)\s*$/)
    if (!m) continue
    const title = m[1].trim()
    if (!title) continue
    h2s.push({ title, slug: slugger.slug(title) })
  }
  return h2s
}
